import type { UploadScope } from '#storage/keys'

/** What each scope accepts, and how big. A scope is a policy, not just a folder. */
export const SCOPE_RULES: Record<
  UploadScope,
  { contentTypes: readonly string[]; maxBytes: number }
> = {
  'company-logo': { contentTypes: ['image/png', 'image/jpeg', 'image/webp'], maxBytes: 2_000_000 },
  'passport-scan': {
    contentTypes: ['image/png', 'image/jpeg', 'application/pdf'],
    maxBytes: 10_000_000,
  },
  'badge-template': { contentTypes: ['application/pdf', 'image/png'], maxBytes: 5_000_000 },
  'tenant-branding': {
    contentTypes: ['image/png', 'image/jpeg', 'image/svg+xml', 'image/x-icon'],
    maxBytes: 2_000_000,
  },
  'cms-media': {
    contentTypes: [
      'image/png',
      'image/jpeg',
      'image/webp',
      'image/avif',
      'image/gif',
      'application/pdf',
    ],
    maxBytes: 25_000_000,
  },
  import: {
    contentTypes: ['text/csv', 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'],
    maxBytes: 20_000_000,
  },
  'payment-proof': {
    contentTypes: ['image/png', 'image/jpeg', 'application/pdf'],
    maxBytes: 10_000_000,
  },
  'profile-document': {
    contentTypes: ['image/png', 'image/jpeg', 'application/pdf'],
    maxBytes: 10_000_000,
  },
  'speaker-photo': { contentTypes: ['image/png', 'image/jpeg', 'image/webp'], maxBytes: 5_000_000 },
  'session-material': {
    contentTypes: ['application/pdf', 'image/png', 'image/jpeg'],
    maxBytes: 25_000_000,
  },
  // A venue plan is sharp only at a high resolution, so it may be large.
  'venue-plan': {
    contentTypes: ['image/png', 'image/jpeg', 'image/webp', 'image/svg+xml'],
    maxBytes: 20_000_000,
  },
  // A stand's fit-out: the fascia logo, the contractor's documents and the design drawings. A
  // drawing can be a large PDF.
  'fit-out-document': {
    contentTypes: ['application/pdf', 'image/png', 'image/jpeg', 'image/webp', 'image/svg+xml'],
    maxBytes: 25_000_000,
  },
}
